import { render, staticRenderFns } from "./ProfessionVersionUpload.vue?vue&type=template&id=43068c89&scoped=true&"
import script from "./ProfessionVersionUpload.vue?vue&type=script&lang=js&"
export * from "./ProfessionVersionUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionVersionUpload.vue?vue&type=style&index=0&id=43068c89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43068c89",
  null
  
)

export default component.exports